module.exports = __webpack_public_path__ + "static/media/inside.d6348ad7.svg";